import React, { useMemo, useState } from 'react';
import axios from 'axios';
import useDetailFetch from '../../../../hooks/useDetailFetch';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { useParams, useNavigate } from 'react-router-dom';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { ToastContext } from '../../../../context/ToastContext';
import ConfirmModal from '../../../Reusable_Components/ConfirmModal';

const SingleSalesTeamDetails = () => {
  const { teamId } = useParams();
  const navigate = useNavigate();
  const { showToast } = React.useContext(ToastContext);

  const decodedId = teamId ? atob(teamId) : teamId;
  const id = decodedId.replace(/\D/g, '');

  const [showDelete, setShowDelete] = useState(false);

  const url = id ? API_DOMAIN + API_ROUTES['salesTeam'] + id + '/' : null;
  const { data: details, loading } = useDetailFetch(url);

  const columns = useMemo(() => {
    if (!details) return null;
    const excluded = ['id', 'updated_at', 'created_at'];
    return Object.keys(details)
      .filter(c => !excluded.includes(c))
      .map(c => ({ label: c.charAt(0).toUpperCase() + c.slice(1), field: c }));
  }, [details]);

  const handleDelete = async () => {
    try {
      await axios.delete(API_DOMAIN + API_ROUTES['salesTeam'] + id + '/', { headers });
      showToast('Sales Team deleted successfully', 'success');
      navigate('/lead/sales-team/list');
    } catch (error) {
      console.error('Error deleting Sales Team:', error);
      showToast('Error deleting Sales Team', 'error');
    }
  };

  return (
    <div>
      <SingleItemDetailTemplate
        details={details}
        columns={columns}
        entityName="Sales Team"
        listPath="/lead/sales-team/list"
        editPath={`/lead/sales-team/input/${btoa(id)}`}
        onDelete={() => setShowDelete(true)}
        loading={loading}
      />
      <ConfirmModal
        isOpen={showDelete}
        title="Delete Sales Team"
        message="Are you sure you want to delete this Sales Team? This action cannot be undone."
        onConfirm={handleDelete}
        onCancel={() => setShowDelete(false)}
      />
    </div>
  );
};

export default SingleSalesTeamDetails;
